import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TooltipPosition } from '@angular/material/tooltip';
import { ActivatedRoute, Params } from '@angular/router';
import { Notification } from 'src/app/core/Notifications/Notification';
import { environment } from 'src/environments/environment';
import { ConsultationHistoryService } from '../consultation-history.service';

@Component({
  selector: 'app-consultation-view',
  templateUrl: './consultation-view.component.html',
  styleUrls: ['./consultation-view.component.scss']
})
export class ConsultationViewComponent implements OnInit {
  viewhid: boolean = false;
  data: any;
  TooltipPosition: TooltipPosition[] = ['above'];
  coN_Id: any;
  revisit: any;
  CON_Id: any;
  constructor(private fb: FormBuilder, private notif: Notification, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private _data: any, private service: ConsultationHistoryService, private route: ActivatedRoute) { }
  package_desc1 = true;
  package_desc2 = true;
  package_desc3 = true;
  package_desc4 = true;
  package_desc5 = true;
  package_desc6 = true;
  package_desc7 = true;
  ngOnInit(): void {
    this.Get_Consultation_id();
    this.Get_diagbyid();
    this.Get_drugpresbyid();
    this.get_labtestbyid();
    this.Get_dietbyid();
    this.Get_refarelbyid();
    this.get_document();
    this.data = this._data.d;
    let id = +this.route.snapshot.params['id'];
    this.route.params.subscribe((params: Params) => {
      id = +params['id'];
      this.coN_Id = id;
      // console.log("Grid data:",JSON.stringify(this._data.d))
    });
    this.Get_revisitbyid();
  }

  documentdetails: any;
  Image_Url: any;
  
  get_document() {
    this.service.Get_documentdetail_patientid(this._data.d.coN_PR_Id_FK)
      .subscribe((res) => {
        this.documentdetails = res
        this.Image_Url = environment.Image_Url + 'PatientDocuments';
      })
  }
  Get_Consultation_id() {
    this.service.Get_Consultation_id(this._data.d.coN_Id)
      .subscribe((data) => {
        this.data = data
        console.log("Consultation Details:", JSON.stringify(this.data))
        // if (this.data.serviceCode == 'PK0001') {
        //   this.package_desc1 = false
        // }
        // else if (this.data.serviceCode == 'PK0002') {
        //   this.package_desc1 = false
        //   this.package_desc2 = false
        // }
        // else if (this.data.serviceCode == 'PK0003') {
        //   this.package_desc1 = false
        //   this.package_desc2 = false
        //   this.package_desc3 = false
        // }
        // else if (this.data.serviceCode == 'PK0004') {
        //   this.package_desc1 = false
        //   this.package_desc2 = false
        //   this.package_desc3 = false
        //   this.package_desc4 = false
        // }
        // else if (this.data.serviceCode == 'PK0005') {
        //   this.package_desc1 = false
        //   this.package_desc2 = false
        //   this.package_desc3 = false
        //   this.package_desc4 = false
        //   this.package_desc5 = false
        // }
        // else if (this.data.serviceCode == 'PK0006') {
        //   this.package_desc1 = false
        //   this.package_desc2 = false
        //   this.package_desc3 = false
        //   this.package_desc4 = false
        //   this.package_desc5 = false
        //   this.package_desc6 = false
        // }
        // else {
        //   this.notif.errorsmsg('No Vitals Found')
        // }
      })
  }

  data1: any;
  Get_diagbyid() {
    this.service.Get_diagnosisbyid(this._data.d.coN_Id)
      .subscribe((data) => {
        this.data1 = data
      });
  }

  data2: any;
  Get_drugpresbyid() {
    this.service.Get_drugpresby_id(this._data.d.coN_Id)
      .subscribe((data) => {
        this.data2 = data
      });
  }

  data3: any;
  get_labtestbyid() {
    this.service.get_labtestbyid(this._data.d.coN_Id)
      .subscribe((data) => {
        this.data3 = data
      });
  }
  data4: any;
  Get_dietbyid() {
    this.service.Get_dietbyid(this._data.d.coN_Id)
      .subscribe((data) => {
        this.data4 = data
      });
  }

  data5: any;
  Get_refarelbyid() {
    this.service.Get_referralby_id(this._data.d.coN_Id)
      .subscribe((data) => {
        this.data5 = data
      });
  }
  data6: any;
  Get_revisitbyid() {
    this.service.Get_revistby_id(this._data.d.coN_Id)
      .subscribe((data) => {
        this.data6 = data
      });
  }

  calculateBMI(): string {
    if (this.data.coN_Height && this.data.coN_Weight) {
      // Convert height from cm to meters (1 cm = 0.01 m)
      const heightInMeters = this.data.coN_Height / 100;

      // Calculate BMI
      const bmi = this.data.coN_Weight / (heightInMeters * heightInMeters);

      // Format BMI to display in metric square
      return bmi.toFixed(2) + ' kg/m²';
    }
    // Return an empty string or an appropriate message if height or weight is missing.
    return 'N/A';
  }


}
